import { PositionJobFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Профессия должности — справочное значение, а не свободный текст: показывается
 * локализованное название элемента справочника, а не его код.
 */
export function PositionJob({ data }: { data?: Hidable<PositionJobFragment> }) {
  return (
    <Value data={data}>
      {(position) => <LocalizedName data={position.job.value} />}
    </Value>
  );
}
